import { z } from "zod";

// addressSchema is the shared structured-address shape reused by the canteiro
// create/edit forms. lat/lng are optional numbers populated by the CEP lookup
// or the map pin.
export const addressSchema = z.object({
	street: z.string().trim().min(1, "Informe a rua"),
	number: z.string().trim().min(1, "Informe o número"),
	complement: z.string().trim().optional(),
	neighborhood: z.string().trim().min(1, "Informe o bairro"),
	city: z.string().trim().min(1, "Informe a cidade"),
	state: z
		.string()
		.trim()
		.regex(/^[A-Za-z]{2}$/, "UF com 2 letras"),
	zipcode: z
		.string()
		.trim()
		.regex(/^\d{5}-?\d{3}$/, "CEP inválido (00000-000)"),
	lat: z.number().optional(),
	lng: z.number().optional(),
});

export type AddressFormValues = z.infer<typeof addressSchema>;
